//import axios from "../utils/axios";

import { deleteAccountOTPConfirm } from "actions/contactActions";
import { CONTACT_US_URL, DELETE_MY_ACCOUNT_REQ_OTP_URL, REGISTER_BUSINESS_URL } from "config/services";
import axios from "utils/axios";


class ContactService {
  contactUs = (payload) => {
    new Promise((resolve, reject) => {

      // console.log("contactUs() service values", payload);

      axios
        .post(CONTACT_US_URL, payload)
        .then((response) => {
          //console.log("budgetServices:budget", response.data);
          if (response?.data?.error) {
            reject(response?.data?.error);
          } else {
            // console.log(
            //   "Response:addbudget:error " + JSON.stringify(response.data)
            // );
            resolve(response.data.payload);
          }
        })
        .catch((error) => {
          // console.log("budgetService:addbudget:error", error);
          reject(error);
        });
    });
  };

  registerBusiness = (payload) => {
    new Promise((resolve, reject) => {
      axios
        .post(REGISTER_BUSINESS_URL, payload)
        .then((response) => {
          // console.log("budgetServices:budget", response.data);
          if (response?.data?.error) {
            reject(response?.data?.error);
          } else {
            // console.log(
            //   "Response:addbudget:error " + JSON.stringify(response.data)
            // );
            resolve(response.data.payload);
          }
        })
        .catch((error) => {
          // console.log("budgetService:addbudget:error", error);
          reject(error);
        });
    });
  };

  deleteAccountOTPReq = (appName, mobile) => {
    new Promise((resolve, reject) => {
      axios
        .post(DELETE_MY_ACCOUNT_REQ_OTP_URL, { appName, mobile })
        .then((response) => {
          // console.log("budgetServices:budget", response.data);
          if (response?.data?.error) {
            reject(response?.data?.error);
          } else {
            // console.log(
            //   "Response:addbudget:error " + JSON.stringify(response.data)
            // );
            resolve(response.data.payload);
          }
        })
        .catch((error) => {
          // console.log("budgetService:addbudget:error", error);
          reject(error);
        });
    });
  }

  deleteAccountOTPConfirm = (appName, mobile, otp) => {
    new Promise((resolve, reject) => {
      axios
        .post(DELETE_MY_ACCOUNT_REQ_OTP_URL, { appName, mobile, otp })
        .then((response) => {
          // console.log("budgetServices:budget", response.data);
          if (response?.data?.error) {
            reject(response?.data?.error);
          } else {
            // console.log(
            //   "Response:addbudget:error " + JSON.stringify(response.data)
            // );
            resolve(response.data.payload);
          }
        })
        .catch((error) => {
          // console.log("budgetService:addbudget:error", error);
          reject(error);
        });
    });

  }

}

const contactService = new ContactService();

export default contactService;
